import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { IOrderDTO, EnumOrderType } from '../../type';
import OrderDefault from '../../../../assets/newcustomerservice/order_default.png';
import Shop from '../../../../assets/customerService/shop.png';
import Recipient from '../../../../assets/customerService/recipient.png';
import TranslationBtn from '../../../../assets/customerService/translation_btn.png';
import RightArrow from '../../../../assets/customerService/smallRightArrow.png';
import Items from '../../../../assets/customerService/items.png';
import OrderInfo from '../../../../assets/customerService/orderInfo.png';
import i18nClient from '../../locales/i18n.config';
import { getTranslatedAddress } from '../../api/index';
import { lxClickReport } from '../../lib/lx';
import { CustomerCid } from '../../contant';
import { EnumBizLine, EnumLxPositionName } from '../../lib/constant';
import './index.css';

interface IProps {
  order: IOrderDTO;
  hiddenIcon?: boolean;
  visitId?: string;
  from?: string;
}

const Toast = Mach.requireModule('Toast');

export default function OrderItem(props: IProps) {
  const [order, setOrder] = useState(props.order);
  const [translateDisabled, setTranslateDisabled] = useState(false);
  const orderType = order?.orderType || EnumOrderType.Order;
  const bundleName = Mach.env.bundleName;

  useEffect(() => {
    if (props.order && order?.orderId !== props.order?.orderId) setOrder(props.order);
  }, [props.order, order?.orderId]);

  const handleAddressTranslate = async (order: IOrderDTO): Promise<void> => {
    const cid = {
      mach_pro_sailor_c_customer_service: CustomerCid.HomePage,
      mach_pro_sailor_c_customer_service_order: CustomerCid.OrderPage,
    };
    lxClickReport(cid[bundleName] || CustomerCid.HomePage, 'b_oversea_helpcenter_kirii8m1_mc', {
      event_name: '问题答案页面翻译按钮点击',
      order_id: order?.orderId,
      order_type: EnumOrderType.Rider,
      position_name: EnumLxPositionName.OrderCard,
      visitId: props?.visitId,
      from: props?.from,
      bizline: EnumBizLine.KEETA, //D端订单卡片，只会是kfood
    });
    const params = {
      contents: [order?.recipientAddress] as string[],
      sourceLanguage: order?.extend?.customerAddressLanguage,
    };
    try {
      const result = await getTranslatedAddress(params, props?.visitId);
      if (result && order?.extend) {
        const updatedOrder = {
          ...order,
          extend: {
            ...order?.extend,
            translateAddress: result?.translateTexts?.[0],
          },
        };
        setOrder(updatedOrder);
        setTranslateDisabled(true);
      } else {
        Toast.show(i18nClient.getText('cs_portal_translation_failed_click_retry', 'Translation failed, please click to retry.'));
      }
    } catch (error) {
      Toast.show(i18nClient.getText('cs_portal_translation_failed_click_retry', 'Translation failed, please click to retry.'));
    }
  };

  const handleClickTranslate = () => {
    if (translateDisabled) return;
    handleAddressTranslate(order);
  };

  const renderCOrder = () => (
    <view className="order-item">
      <view className="order-item-left">
        <image className="order-item-icon" src={order?.orderImageUrl} error={OrderDefault} />
      </view>
      <view className="order-item-box">
        <view className="order-item-content">
          <view className="order-item-title-wrapper">
            {order?.userGetMode && <text className="order-item-tag">{order?.userGetMode}</text>}
            <text className="order-item-content-title">{order?.orderTitle}</text>
          </view>
          <text className="order-item-content-status">{order?.orderStatus}</text>
        </view>
        <view className="order-item-info">
          <text className="order-item-info-desc">{order?.orderContentList?.join('、')}</text>
          <text className="order-item-info-count">{order?.orderPrice}</text>
        </view>
      </view>
    </view>
  );

  const renderBOrder = () => (
    <view className="wai-mai-shop-item">
      <view className="wai-mai-shop-item-content">
        <view className="wai-mai-shop-item-content-id">
          <text className="wai-mai-shop-item-content-id-symbol">#</text>
          <text className="wai-mai-shop-item-content-title">{ order?.orderSeqNo}</text>
          {
            order?.userGetMode && <text className="wai-mai-shop-item-content-id-tag">{ order?.userGetMode }</text>
          }
        </view>
        <text
          className={clsx(
            'wai-mai-shop-item-content-status',
            ['Canceled', '已取消', 'ملغى'].includes(order?.orderStatus) ? 'fail' : ''
          )}
        >
          { order?.orderStatus }
        </text>
      </view>
      <view className="wai-mai-shop-item-time">
        <text>{ i18nClient.getText('cs_portal_order_placement_time', 'Order time') }</text>
        <text> { order?.orderTime } </text>
      </view>
    </view>
  );

  const renderDOrder = () => (
    <view className="rider-item">
      <view className="rider-item-title">
        <text className="rider-item-time">{ order?.orderTime }</text>
        { !props?.hiddenIcon && <image src={RightArrow} className="icon_arrow_right-small" autoRTL />}
      </view>
      <view class="rider-item-address">
        <view className="rider-item-address-content">
          <image src={Shop} className="rider-item-address-content-img" />
          <text className="rider-item-address-content-text">{ order?.senderAddress }</text>
        </view>
        {
          order?.recipientAddress && (
            <view className="rider-item-address-content">
              <image src={Recipient} className="rider-item-address-content-img" />
              <text className="rider-item-address-content-span">{ order?.recipientAddress }</text>
              {
                order?.extend && order?.extend?.isShowTranslateButton && (
                  <view className="rider-item-address-img-content-translation-btn" onClick={handleClickTranslate}>
                    <image
                      src={TranslationBtn} className={`rider-item-address-img-content-translation-img ${translateDisabled ? 'rider-item-address-img-content-translation-img-disabled' : ''}`}
                      autoRTL
                    />
                  </view>
                )
              }
            </view>
          )
        }
        {
          order?.extend?.translateAddress && (
            <view className="rider-item-address-trnslate-content">
              <text className="rider-item-address-translation-text">
                { order?.extend?.translateAddress }
              </text>
            </view>
          )
        }
      </view>
    </view>
  );

  const renderKeemartDOrder = () => (
    <view className="keemart-rider-item">
      <view className="keemart-rider-item-title">
        <text className="keemart-rider-item-seqNo">{ order?.orderSeqNo }</text>
        <view>
          <text className="keemart-rider-item-status">{ order?.orderStatus }</text>
          { !props?.hiddenIcon && <image src={RightArrow} className="keemart-rider-item-arrow" autoRTL />}
        </view>
      </view>
      <text className="keemart-rider-item-time">{ order?.orderTime }</text>
      <view class="keemart-rider-item-content">
        <view className="keemart-rider-item-detail">
          <image src={Items} className="keemart-rider-item-img" />
          <text className="keemart-rider-item-text">
            {`${i18nClient.getText('cs_portal_rider_item', {
              num: order?.itemQuantity,
              pluralCount: order?.itemQuantity,
              defaultValue: `${order?.itemQuantity} items`
            })}, ${order?.totalWeight}`}
          </text>
          {/* <text className="keemart-rider-item-detail-text">{ order?.senderAddress }</text> */}
        </view>
        <view className="keemart-rider-item-orderId">
          <image src={OrderInfo} className="keemart-rider-item-img" />
          <text className="keemart-rider-item-text">{ order?.extend?.orderId }</text>
        </view>
      </view>
    </view>
  );

  const orderItem = {
    [EnumOrderType.Order]: renderCOrder(),
    [EnumOrderType.WaiMaiShop]: renderBOrder(),
    [EnumOrderType.Rider]: renderDOrder(),
    [EnumOrderType.KeemartRider]: renderKeemartDOrder(),
  };

  return orderItem[orderType];
}
